module.exports = __webpack_public_path__ + "img/JDD-min.293cd9a0.png";